import { getAgencyId, getCitizenAuthHeaders } from '@private-crm-app/utils';

import { CALL_API } from '../middleware/ApiMiddleware';

export const VALIDATE_CRM_REQUEST = 'VALIDATE_CRM_REQUEST';
export const VALIDATE_CRM_SUCCESS = 'VALIDATE_CRM_SUCCESS';
export const VALIDATE_CRM_FAILURE = 'VALIDATE_CRM_FAILURE';

export const SAVE_CRM_ANONYMOUS_ISSUE_DETAILS_REQUEST = 'SAVE_CRM_ANONYMOUS_ISSUE_DETAILS_REQUEST';
export const SAVE_CRM_ANONYMOUS_ISSUE_DETAILS_SUCCESS = 'SAVE_CRM_ANONYMOUS_ISSUE_DETAILS_SUCCESS';
export const SAVE_CRM_ANONYMOUS_ISSUE_DETAILS_FAILURE = 'SAVE_CRM_ANONYMOUS_ISSUE_DETAILS_FAILURE';

export const GET_CRM_ANONYMOUS_ISSUE_DETAILS_REQUEST = 'GET_CRM_ANONYMOUS_ISSUE_DETAILS_REQUEST';
export const GET_CRM_ANONYMOUS_ISSUE_DETAILS_SUCCESS = 'GET_CRM_ANONYMOUS_ISSUE_DETAILS_SUCCESS';
export const GET_CRM_ANONYMOUS_ISSUE_DETAILS_FAILURE = 'GET_CRM_ANONYMOUS_ISSUE_DETAILS_FAILURE';

export const CUSTOMER_SUBMISSION_LIST_FETCH_REQUEST = 'CUSTOMER_SUBMISSION_LIST_FETCH_REQUEST';
export const CUSTOMER_SUBMISSION_LIST_FETCH_SUCCESS = 'CUSTOMER_SUBMISSION_LIST_FETCH_SUCCESS';
export const CUSTOMER_SUBMISSION_LIST_FETCH_FAILURE = 'CUSTOMER_SUBMISSION_LIST_FETCH_FAILURE';

export const CUSTOMER_SUBMISSION_FETCH_REQUEST = 'CUSTOMER_SUBMISSION_FETCH_REQUEST';
export const CUSTOMER_SUBMISSION_FETCH_SUCCESS = 'CUSTOMER_SUBMISSION_FETCH_SUCCESS';
export const CUSTOMER_SUBMISSION_FETCH_FAILURE = 'CUSTOMER_SUBMISSION_FETCH_FAILURE';

export const UPDATE_CUSTOMER_SUBMISSION_STATUS_REQUEST = 'UPDATE_CUSTOMER_SUBMISSION_STATUS_REQUEST';
export const UPDATE_CUSTOMER_SUBMISSION_STATUS_SUCCESS = 'UPDATE_CUSTOMER_SUBMISSION_STATUS_SUCCESS';
export const UPDATE_CUSTOMER_SUBMISSION_STATUS_FAILURE = 'UPDATE_CUSTOMER_SUBMISSION_STATUS_FAILURE';

export const GET_CUSTOMER_SUBMISSION_HISTORY_REQUEST = 'GET_CUSTOMER_SUBMISSION_HISTORY_REQUEST';
export const GET_CUSTOMER_SUBMISSION_HISTORY_SUCCESS = 'GET_CUSTOMER_SUBMISSION_HISTORY_SUCCESS';
export const GET_CUSTOMER_SUBMISSION_HISTORY_FAILURE = 'GET_CUSTOMER_SUBMISSION_HISTORY_FAILURE';

export const DOWNLOAD_CS_LIST_CSV_REQUEST = 'DOWNLOAD_CS_LIST_CSV_REQUEST';
export const DOWNLOAD_CS_LIST_CSV_SUCCESS = 'DOWNLOAD_CS_LIST_CSV_SUCCESS';
export const DOWNLOAD_CS_LIST_CSV_FAILURE = 'DOWNLOAD_CS_LIST_CSV_FAILURE';

export const CLEAR_CUSTOMER_SUBMISSION = 'CLEAR_CUSTOMER_SUBMISSION';

export const SUBMIT_ISSUE_REQUEST = 'SUBMIT_ISSUE_REQUEST';
export const SUBMIT_ISSUE_SUCCESS = 'SUBMIT_ISSUE_SUCCESS';
export const SUBMIT_ISSUE_FAILURE = 'SUBMIT_ISSUE_FAILURE';

export const CREATE_SUBMISSION_REQUEST = 'CREATE_SUBMISSION_REQUEST';
export const CREATE_SUBMISSION_SUCCESS = 'CREATE_SUBMISSION_SUCCESS';
export const CREATE_SUBMISSION_FAILURE = 'CREATE_SUBMISSION_FAILURE';

export const DELETE_SUBMISSION_REQUEST = 'DELETE_SUBMISSION_REQUEST';
export const DELETE_SUBMISSION_SUCCESS = 'DELETE_SUBMISSION_SUCCESS';
export const DELETE_SUBMISSION_FAILURE = 'DELETE_SUBMISSION_FAILURE';

export const EDIT_CRM_ASSIGNEE_REQUEST = 'EDIT_CRM_ASSIGNEE_REQUEST';
export const EDIT_CRM_ASSIGNEE_SUCCESS = 'EDIT_CRM_ASSIGNEE_SUCCESS';
export const EDIT_CRM_ASSIGNEE_FAILURE = 'EDIT_CRM_ASSIGNEE_FAILURE';

export const EDIT_CS_VISIBILITY_REQUEST = 'EDIT_CS_VISIBILITY_REQUEST';
export const EDIT_CS_VISIBILITY_SUCCESS = 'EDIT_CS_VISIBILITY_SUCCESS';
export const EDIT_CS_VISIBILITY_FAILURE = 'EDIT_CS_VISIBILITY_FAILURE';

export const EDIT_CS_DISPLAY_ON_PUBLIC_MAP_REQUEST = 'EDIT_CS_DISPLAY_ON_PUBLIC_MAP_REQUEST';
export const EDIT_CS_DISPLAY_ON_PUBLIC_MAP_SUCCESS = 'EDIT_CS_DISPLAY_ON_PUBLIC_MAP_SUCCESS';
export const EDIT_CS_DISPLAY_ON_PUBLIC_MAP_FAILURE = 'EDIT_CS_DISPLAY_ON_PUBLIC_MAP_FAILURE';

export const EDIT_CS_CATEGORY_REQUEST = 'EDIT_CS_CATEGORY_REQUEST';
export const EDIT_CS_CATEGORY_SUCCESS = 'EDIT_CS_CATEGORY_SUCCESS';
export const EDIT_CS_CATEGORY_FAILURE = 'EDIT_CS_CATEGORY_FAILURE';

export const EDIT_CS_CATEGORY_FIELDS_REQUEST = 'EDIT_CS_CATEGORY_FIELDS_REQUEST';
export const EDIT_CS_CATEGORY_FIELDS_SUCCESS = 'EDIT_CS_CATEGORY_FIELDS_SUCCESS';
export const EDIT_CS_CATEGORY_FIELDS_FAILURE = 'EDIT_CS_CATEGORY_FIELDS_FAILURE';

export const GET_CRM_MAP_CONFIG_REQUEST = 'GET_CRM_MAP_CONFIG_REQUEST';
export const GET_CRM_MAP_CONFIG_SUCCESS = 'GET_CRM_MAP_CONFIG_SUCCESS';
export const GET_CRM_MAP_CONFIG_FAILURE = 'GET_CRM_MAP_CONFIG_FAILURE';

export const CRM_ADD_ATTACHMENT_REQUEST = 'CRM_ADD_ATTACHMENT_REQUEST';
export const CRM_ADD_ATTACHMENT_SUCCESS = 'CRM_ADD_ATTACHMENT_SUCCESS';
export const CRM_ADD_ATTACHMENT_FAILURE = 'CRM_ADD_ATTACHMENT_FAILURE';

export const CRM_DELETE_ATTACHMENT_REQUEST = 'CRM_DELETE_ATTACHMENT_REQUEST';
export const CRM_DELETE_ATTACHMENT_SUCCESS = 'CRM_DELETE_ATTACHMENT_SUCCESS';
export const CRM_DELETE_ATTACHMENT_FAILURE = 'CRM_DELETE_ATTACHMENT_FAILURE';

export const CRM_DELETE_ATTACHMENTS_BY_ID = 'CRM_DELETE_ATTACHMENTS_BY_ID';

export const CRM_LOCATION_SEARCH_REQUEST = 'CRM_LOCATION_SEARCH_REQUEST';
export const CRM_LOCATION_SEARCH_SUCCESS = 'CRM_LOCATION_SEARCH_SUCCESS';
export const CRM_LOCATION_SEARCH_FAILURE = 'CRM_LOCATION_SEARCH_FAILURE';

export const CRM_LOCATION_SEARCH_CLEAR = 'CRM_LOCATION_SEARCH_CLEAR';

export const CRM_EDIT_LOCATION_REQUEST = 'CRM_EDIT_LOCATION_REQUEST';
export const CRM_EDIT_LOCATION_SUCCESS = 'CRM_EDIT_LOCATION_SUCCESS';
export const CRM_EDIT_LOCATION_FAILURE = 'CRM_EDIT_LOCATION_FAILURE';

export const CRM_ENTER_DRAFT_MODE = 'CRM_ENTER_DRAFT_MODE';
export const CRM_EXIT_DRAFT_MODE = 'CRM_EXIT_DRAFT_MODE';
export const CRM_LOCATION_UPDATE = 'CRM_LOCATION_UPDATE';

export const EDIT_CS_COLLABORATOR_REQUEST = 'EDIT_CS_COLLABORATOR_REQUEST';
export const EDIT_CS_COLLABORATOR_SUCCESS = 'EDIT_CS_COLLABORATOR_SUCCESS';
export const EDIT_CS_COLLABORATOR_FAILURE = 'EDIT_CS_COLLABORATOR_FAILURE';

export const CRM_SUGGESTED_CATEGORIES_FETCH_REQUEST = 'CRM_SUGGESTED_CATEGORIES_FETCH_REQUEST';
export const CRM_SUGGESTED_CATEGORIES_FETCH_SUCCESS = 'CRM_SUGGESTED_CATEGORIES_FETCH_SUCCESS';
export const CRM_SUGGESTED_CATEGORIES_FETCH_FAILURE = 'CRM_SUGGESTED_CATEGORIES_FETCH_FAILURE';

export const GET_DUPLICATE_ISSUES_REQUEST = 'GET_DUPLICATE_ISSUES_REQUEST';
export const GET_DUPLICATE_ISSUES_SUCCESS = 'GET_DUPLICATE_ISSUES_SUCCESS';
export const GET_DUPLICATE_ISSUES_FAILURE = 'GET_DUPLICATE_ISSUES_FAILURE';

export const GET_STAFF_DUPLICATE_ISSUES_REQUEST = 'GET_STAFF_DUPLICATE_ISSUES_REQUEST';
export const GET_STAFF_DUPLICATE_ISSUES_SUCCESS = 'GET_STAFF_DUPLICATE_ISSUES_SUCCESS';
export const GET_STAFF_DUPLICATE_ISSUES_FAILURE = 'GET_STAFF_DUPLICATE_ISSUES_FAILURE';

export const UPDATE_EMAIL_READ_STATUS_REQUEST = 'UPDATE_EMAIL_READ_STATUS_REQUEST';
export const UPDATE_EMAIL_READ_STATUS_SUCCESS = 'UPDATE_EMAIL_READ_STATUS_SUCCESS';
export const UPDATE_EMAIL_READ_STATUS_FAILURE = 'UPDATE_EMAIL_READ_STATUS_FAILURE';

export const SEND_CS_EMAIL_REQUEST = 'SEND_CS_EMAIL_REQUEST';
export const PREVIEW_CS_MESSAGE_TRANSLATION_REQUEST = 'PREVIEW_CS_MESSAGE_TRANSLATION_REQUEST';
export const PREVIEW_CS_MESSAGE_TRANSLATION_SUCCESS = 'PREVIEW_CS_MESSAGE_TRANSLATION_SUCCESS';
export const PREVIEW_CS_MESSAGE_TRANSLATION_FAILURE = 'PREVIEW_CS_MESSAGE_TRANSLATION_FAILURE';
export const SEND_CS_EMAIL_SUCCESS = 'SEND_CS_EMAIL_SUCCESS';
export const SEND_CS_EMAIL_FAILURE = 'SEND_CS_EMAIL_FAILURE';

export const ADD_CRM_ISSUE_NOTE_REQUEST = 'ADD_CRM_ISSUE_NOTE_REQUEST';
export const ADD_CRM_ISSUE_NOTE_SUCCESS = 'ADD_CRM_ISSUE_NOTE_SUCCESS';
export const ADD_CRM_ISSUE_NOTE_FAILURE = 'ADD_CRM_ISSUE_NOTE_FAILURE';

export const UPDATE_CRM_ISSUE_ESCALATION_REQUEST = 'UPDATE_CRM_ISSUE_ESCALATION_REQUEST';
export const UPDATE_CRM_ISSUE_ESCALATION_SUCCESS = 'UPDATE_CRM_ISSUE_ESCALATION_SUCCESS';
export const UPDATE_CRM_ISSUE_ESCALATION_FAILURE = 'UPDATE_CRM_ISSUE_ESCALATION_FAILURE';

export const DELETE_CRM_ISSUE_NOTE_REQUEST = 'DELETE_CRM_ISSUE_NOTE_REQUEST';
export const DELETE_CRM_ISSUE_NOTE_SUCCESS = 'DELETE_CRM_ISSUE_NOTE_SUCCESS';
export const DELETE_CRM_ISSUE_NOTE_FAILURE = 'DELETE_CRM_ISSUE_NOTE_FAILURE';

export const EDIT_CRM_ISSUE_NOTE_REQUEST = 'EDIT_CRM_ISSUE_NOTE_REQUEST';
export const EDIT_CRM_ISSUE_NOTE_SUCCESS = 'EDIT_CRM_ISSUE_NOTE_SUCCESS';
export const EDIT_CRM_ISSUE_NOTE_FAILURE = 'EDIT_CRM_ISSUE_NOTE_FAILURE';

export const EDIT_SUBMISSION_TASK_REQUEST = 'EDIT_SUBMISSION_TASK_REQUEST';
export const EDIT_SUBMISSION_TASK_SUCCESS = 'EDIT_SUBMISSION_TASK_SUCCESS';
export const EDIT_SUBMISSION_TASK_FAILURE = 'EDIT_SUBMISSION_TASK_FAILURE';

export const FETCH_SUBMISSION_TASK_SUCCESS = 'FETCH_SUBMISSION_TASK_SUCCESS';
export const FETCH_SUBMISSION_TASK_FAILURE = 'FETCH_SUBMISSION_TASK_FAILURE';
export const FETCH_SUBMISSION_TASK_REQUEST = 'FETCH_SUBMISSION_TASK_REQUEST';

export const RESEND_MAGIC_LINK_REQUEST = 'RESEND_MAGIC_LINK_REQUEST';
export const RESEND_MAGIC_LINK_SUCCESS = 'RESEND_MAGIC_LINK_SUCCESS';
export const RESEND_MAGIC_LINK_FAILURE = 'RESEND_MAGIC_LINK_FAILURE';

export const GET_PRIVATE_CSDP_DATA_REQUEST = 'GET_PRIVATE_CSDP_DATA_REQUEST';
export const GET_PRIVATE_CSDP_DATA_SUCCESS = 'GET_PRIVATE_CSDP_DATA_SUCCESS';
export const GET_PRIVATE_CSDP_DATA_FAILURE = 'GET_CSDP_DATA_FAILGET_PRIVATE_CSDP_DATA_FAILUREURE';

export const GET_PRIVATE_CSDP_MESSAGES_REQUEST = 'GET_PRIVATE_CSDP_MESSAGES_REQUEST';
export const GET_PRIVATE_CSDP_MESSAGES_SUCCESS = 'GET_PRIVATE_CSDP_MESSAGES_SUCCESS';
export const GET_PRIVATE_CSDP_MESSAGES_FAILURE = 'GET_PRIVATE_CSDP_MESSAGES_FAILURE';

export const GET_PRIVATE_SUBMISSIONS_LIST_REQUEST = 'GET_PRIVATE_SUBMISSIONS_LIST_REQUEST';
export const GET_PRIVATE_SUBMISSIONS_LIST_SUCCESS = 'GET_PRIVATE_SUBMISSIONS_LIST_SUCCESS';
export const GET_PRIVATE_SUBMISSIONS_LIST_FAILURE = 'GET_PRIVATE_SUBMISSIONS_LIST_FAILURE';

export const EDIT_CRM_ISSUE_DUE_BY_DATE_REQUEST = 'EDIT_CRM_ISSUE_DUE_BY_DATE_REQUEST';
export const EDIT_CRM_ISSUE_DUE_BY_DATE_SUCCESS = 'EDIT_CRM_ISSUE_DUE_BY_DATE_SUCCESS';
export const EDIT_CRM_ISSUE_DUE_BY_DATE_FAILURE = 'EDIT_CRM_ISSUE_DUE_BY_DATE_FAILURE';

export const EDIT_CRM_ISSUE_DESCRIPTION_REQUEST = 'EDIT_CRM_ISSUE_DESCRIPTION_REQUEST';
export const EDIT_CRM_ISSUE_DESCRIPTION_SUCCESS = 'EDIT_CRM_ISSUE_DESCRIPTION_SUCCESS';
export const EDIT_CRM_ISSUE_DESCRIPTION_FAILURE = 'EDIT_CRM_ISSUE_DESCRIPTION_FAILURE';

export const SEND_PRIVATE_CS_MESSAGE_REQUEST = 'SEND_PRIVATE_CS_MESSAGE_REQUEST';
export const SEND_PRIVATE_CS_MESSAGE_SUCCESS = 'SEND_PRIVATE_CS_MESSAGE_SUCCESS';
export const SEND_PRIVATE_CS_MESSAGE_FAILURE = 'SEND_PRIVATE_CS_MESSAGE_FAILURE';

export const FETCH_PRIVATE_SUBMISSION_LIST_LINK_REQUEST = 'FETCH_PRIVATE_SUBMISSION_LIST_LINK_REQUEST';
export const FETCH_PRIVATE_SUBMISSION_LIST_LINK_SUCCESS = 'FETCH_PRIVATE_SUBMISSION_LIST_LINK_SUCCESS';
export const FETCH_PRIVATE_SUBMISSION_LIST_LINK_FAILURE = 'FETCH_PRIVATE_SUBMISSION_LIST_LINK_FAILURE';

export const ADD_SUBMISSION_TASK_REQUEST = 'ADD_SUBMISSION_TASK_REQUEST';
export const ADD_SUBMISSION_TASK_SUCCESS = 'ADD_SUBMISSION_TASK_SUCCESS';
export const ADD_SUBMISSION_TASK_FAILURE = 'ADD_SUBMISSION_TASK_FAILURE';

export const CRM_UPDATE_TASK_STATUS_REQUEST = 'CRM_UPDATE_TASK_STATUS_REQUEST';
export const CRM_UPDATE_TASK_STATUS_SUCCESS = 'CRM_UPDATE_TASK_STATUS_SUCCESS';
export const CRM_UPDATE_TASK_STATUS_FAILURE = 'CRM_UPDATE_TASK_STATUS_FAILURE';

export const DELETE_SUBMISSION_TASK_REQUEST = 'DELETE_SUBMISSION_TASK_REQUEST';
export const DELETE_SUBMISSION_TASK_SUCCESS = 'DELETE_SUBMISSION_TASK_SUCCESS';
export const DELETE_SUBMISSION_TASK_FAILURE = 'DELETE_SUBMISSION_TASK_FAILURE';

export const EDIT_SUBMISSION_TASK_COMMENT_REQUEST = 'EDIT_SUBMISSION_TASK_COMMENT_REQUEST';
export const EDIT_SUBMISSION_TASK_COMMENT_SUCCESS = 'EDIT_SUBMISSION_TASK_COMMENT_SUCCESS';
export const EDIT_SUBMISSION_TASK_COMMENT_FAILURE = 'EDIT_SUBMISSION_TASK_COMMENT_FAILURE';

export const DELETE_SUBMISSION_TASK_COMMENT_REQUEST = 'DELETE_SUBMISSION_TASK_COMMENT_REQUEST';
export const DELETE_SUBMISSION_TASK_COMMENT_SUCCESS = 'DELETE_SUBMISSION_TASK_COMMENT_SUCCESS';
export const DELETE_SUBMISSION_TASK_COMMENT_FAILURE = 'DELETE_SUBMISSION_TASK_COMMENT_FAILURE';

export const ADD_SUBMISSION_TAGS_REQUEST = 'ADD_SUBMISSION_TAGS_REQUEST';
export const ADD_SUBMISSION_TAGS_SUCCESS = 'ADD_SUBMISSION_TAGS_SUCCESS';
export const ADD_SUBMISSION_TAGS_FAILURE = 'ADD_SUBMISSION_TAGS_FAILURE';

export const GROUP_ACTION_REQUEST = 'GROUP_ACTION_REQUEST';
export const GROUP_ACTION_SUCCESS = 'GROUP_ACTION_SUCCESS';
export const GROUP_ACTION_FAILURE = 'GROUP_ACTION_FAILURE';

export const SEND_SUBMISSION_PRINT_REQUEST = 'SEND_SUBMISSION_PRINT_REQUEST';
export const SEND_SUBMISSION_PRINT_SUCCESS = 'SEND_SUBMISSION_PRINT_SUCCESS';
export const SEND_SUBMISSION_PRINT_FAILURE = 'SEND_SUBMISSION_PRINT_FAILURE';

export const CHECK_PRINT_STATUS_REQUEST = 'CHECK_PRINT_STATUS_REQUEST';
export const CHECK_PRINT_STATUS_SUCCESS = 'CHECK_PRINT_STATUS_SUCCESS';
export const CHECK_PRINT_STATUS_FAILURE = 'CHECK_PRINT_STATUS_FAILURE';

export const FETCH_RECENT_TAGS_REQUEST = 'FETCH_RECENT_TAGS_REQUEST';
export const FETCH_RECENT_TAGS_SUCCESS = 'FETCH_RECENT_TAGS_SUCCESS';
export const FETCH_RECENT_TAGS_FAILURE = 'FETCH_RECENT_TAGS_FAILURE';

export const VALIDATE_LOCATION_REQUEST = 'VALIDATE_LOVATION_REQUEST';
export const VALIDATIE_LOCATION_SUCCESS = 'VALIDATION_LOCATION_SUCCESS';
export const VALIDATE_LOCATION_FAILURE = 'VALIDATION_LOCATION_FAILURE';

export const FETCH_SECONDARY_CUSTOM_FIELDS_REQUEST = 'FETCH_SECONDARY_CUSTOM_FIELDS_REQUEST';
export const FETCH_SECONDARY_CUSTOM_FIELDS_SUCCESS = 'FETCH_SECONDARY_CUSTOM_FIELDS_SUCCESS';
export const FETCH_SECONDARY_CUSTOM_FIELDS_FAILURE = 'FETCH_SECONDARY_CUSTOM_FIELDS_FAILURE';

export const FETCH_ATTACHMENT_SOURCE_OPTIONS_REQUEST = 'FETCH_ATTACHMENT_SOURCE_OPTIONS_REQUEST';
export const FETCH_ATTACHMENT_SOURCE_OPTIONS_SUCCESS = 'FETCH_ATTACHMENT_SOURCE_OPTIONS_SUCCESS';
export const FETCH_ATTACHMENT_SOURCE_OPTIONS_FAILURE = 'FETCH_ATTACHMENT_SOURCE_OPTIONS_FAILURE';

export const GET_CRM_CHANNEL_OPTIONS_REQUEST = 'GET_CRM_CHANNEL_OPTIONS_REQUEST';
export const GET_CRM_CHANNEL_OPTIONS_SUCCESS = 'GET_CRM_CHANNEL_OPTIONS_SUCCESS';
export const GET_CRM_CHANNEL_OPTIONS_FAILURE = 'GET_CRM_CHANNEL_OPTIONS_FAILURE';

export const GET_CRM_CLOSURE_OPTIONS_REQUEST = 'GET_CRM_CLOSURE_OPTIONS_REQUEST';
export const GET_CRM_CLOSURE_OPTIONS_SUCCESS = 'GET_CRM_CLOSURE_OPTIONS_SUCCESS';
export const GET_CRM_CLOSURE_OPTIONS_FAILURE = 'GET_CRM_CLOSURE_OPTIONS_FAILURE';

export const GET_SUBMISSION_FOLLOWERS_REQUEST = 'GET_SUBMISSION_FOLLOWERS_REQUEST';
export const GET_SUBMISSION_FOLLOWERS_SUCCESS = 'GET_SUBMISSION_FOLLOWERS_SUCCESS';
export const GET_SUBMISSION_FOLLOWERS_FAILURE = 'GET_SUBMISSION_FOLLOWERS_FAILURE';

export const ADD_SUBMISSION_FOLLOWER_REQUEST = 'ADD_SUBMISSION_FOLLOWER_REQUEST';
export const ADD_SUBMISSION_FOLLOWER_SUCCESS = 'ADD_SUBMISSION_FOLLOWER_SUCCESS';
export const ADD_SUBMISSION_FOLLOWER_FAILURE = 'ADD_SUBMISSION_FOLLOWER_FAILURE';

export const REMOVE_SUBMISSION_FOLLOWER_REQUEST = 'REMOVE_SUBMISSION_FOLLOWER_REQUEST';
export const REMOVE_SUBMISSION_FOLLOWER_SUCCESS = 'REMOVE_SUBMISSION_FOLLOWER_SUCCESS';
export const REMOVE_SUBMISSION_FOLLOWER_FAILURE = 'REMOVE_SUBMISSION_FOLLOWER_FAILURE';

export const CLEAR_ISSUE = 'CLEAR_ISSUE';
export const CLEAR_CUSTOMER_SUBMISSION_LIST = 'CLEAR_CUSTOMER_SUBMISSION_LIST';
const baseURL = 'crm';
const agencyCRMBaseURL = 'agencies/crm';
const agencyCRMIssuesBaseURL = 'agencies/crm/issues';
const agencyCRMIssueTaskBaseURL = 'agencies/crm/task';
const privateCSDPBaseUrl = 'submissions';
const privateCSLPBaseUrl = 'submissions/list';

export const validateCRMToken = (crmToken: string) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${crmToken}`,
    method: 'get',
    authenticated: false,
    types: [VALIDATE_CRM_REQUEST, VALIDATE_CRM_SUCCESS, VALIDATE_CRM_FAILURE],
  },
});

export const saveCRMAnonymousIssueDetails = (
  crmToken: string,
  anonymousId: string,
  issueDetails: ICRMIssueAnonymousDetails
) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${crmToken}/${anonymousId}/save-submission-details`,
    method: 'post',
    body: issueDetails,
    authenticated: false,
    types: [
      SAVE_CRM_ANONYMOUS_ISSUE_DETAILS_REQUEST,
      SAVE_CRM_ANONYMOUS_ISSUE_DETAILS_SUCCESS,
      SAVE_CRM_ANONYMOUS_ISSUE_DETAILS_FAILURE,
    ],
  },
});

export const getCRMAnonymousIssueDetails = (crmToken: string, anonymousId: string) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${crmToken}/${anonymousId}/save-submission-details`,
    method: 'get',
    authenticated: false,
    types: [
      GET_CRM_ANONYMOUS_ISSUE_DETAILS_REQUEST,
      GET_CRM_ANONYMOUS_ISSUE_DETAILS_SUCCESS,
      GET_CRM_ANONYMOUS_ISSUE_DETAILS_FAILURE,
    ],
  },
});

export const clearCustomerSubmissionList = () => ({
  type: CLEAR_CUSTOMER_SUBMISSION_LIST,
});

export const getCustomerSubmissionList = (params?: ICustomerSubmissionListParams, hideLoadingWidget = false) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/listing`,
    method: 'post',
    body: params,
    authenticated: true,
    types: [
      CUSTOMER_SUBMISSION_LIST_FETCH_REQUEST,
      CUSTOMER_SUBMISSION_LIST_FETCH_SUCCESS,
      CUSTOMER_SUBMISSION_LIST_FETCH_FAILURE,
    ],
    hideLoadingWidget,
  },
});

export const submitIssue = (crmToken: string, issueRequest: ICRMIssueSubmissionRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${crmToken}/issues`,
    method: 'post',
    params: {
      userId: issueRequest.userId,
    },
    body: issueRequest,
    authenticated: false,
    types: [SUBMIT_ISSUE_REQUEST, SUBMIT_ISSUE_SUCCESS, SUBMIT_ISSUE_FAILURE],
  },
});

export const getCRMMapConfig = (crmToken: string) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${crmToken}/config`,
    method: 'get',
    authenticated: false,
    types: [GET_CRM_MAP_CONFIG_REQUEST, GET_CRM_MAP_CONFIG_SUCCESS, GET_CRM_MAP_CONFIG_FAILURE],
  },
});

export const searchLocation = (
  crmToken: string,
  params: ICRMSearchParams,
  hideLoadingWidget: boolean = false,
  hideDefaultAlert?: boolean,
  abortSignal?: AbortSignal
) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${crmToken}/location/search`,
    method: 'get',
    authenticated: false,
    params,
    types: [CRM_LOCATION_SEARCH_REQUEST, CRM_LOCATION_SEARCH_SUCCESS, CRM_LOCATION_SEARCH_FAILURE],
    hideLoadingWidget,
    hideDefaultAlert,
    abortSignal,
  },
});

export const clearLocationSearch = () => ({
  type: CRM_LOCATION_SEARCH_CLEAR,
});

export const getCRMSuggestedCategories = (crmToken: string, description: string) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${crmToken}/categories/suggestions`,
    method: 'get',
    authenticated: false,
    params: new URLSearchParams({ description: description?.trim() ?? '' }),
    types: [
      CRM_SUGGESTED_CATEGORIES_FETCH_REQUEST,
      CRM_SUGGESTED_CATEGORIES_FETCH_SUCCESS,
      CRM_SUGGESTED_CATEGORIES_FETCH_FAILURE,
    ],
  },
});

export const getDuplicateIssues = (crmToken: string, params: ICRMDuplicateIssueRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${crmToken}/issues/duplicates`,
    method: 'get',
    authenticated: false,
    params,
    headers: getCitizenAuthHeaders(),
    types: [GET_DUPLICATE_ISSUES_REQUEST, GET_DUPLICATE_ISSUES_SUCCESS, GET_DUPLICATE_ISSUES_FAILURE],
    hideLoadingWidget: true,
    hideDefaultAlert: true,
  },
});

export const getStaffDuplicateIssues = (params: ICRMDuplicateIssueRequest) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/duplicates`,
    method: 'get',
    authenticated: true,
    params,
    types: [GET_STAFF_DUPLICATE_ISSUES_REQUEST, GET_STAFF_DUPLICATE_ISSUES_SUCCESS, GET_STAFF_DUPLICATE_ISSUES_FAILURE],
    hideLoadingWidget: true,
    hideDefaultAlert: true,
  },
});

// Customer Submission details

export const getCustomerSubmission = (customerSubmissionId: number) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/${customerSubmissionId}`,
    method: 'get',
    authenticated: true,
    types: [CUSTOMER_SUBMISSION_FETCH_REQUEST, CUSTOMER_SUBMISSION_FETCH_SUCCESS, CUSTOMER_SUBMISSION_FETCH_FAILURE],
  },
});

export const deleteCustomerSubmission = (customerSubmissionId: number) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/${customerSubmissionId}`,
    method: 'delete',
    authenticated: true,
    types: [DELETE_SUBMISSION_REQUEST, DELETE_SUBMISSION_SUCCESS, DELETE_SUBMISSION_FAILURE],
  },
});

export const updateCustomerSubmissionStatus = (
  customerSubmissionId: number,
  status: CustomerSubmissionStatus,
  closedReasonId?: number | null,
  hideDefaultAlert?: boolean
) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/${customerSubmissionId}/status`,
    method: 'put',
    body: closedReasonId != null ? { status, closedReasonId } : { status },
    authenticated: true,
    // Opt-in, and only for a caller that renders the failure itself: CloseSubmissionModal does,
    // so the global alert would duplicate it. The legacy confirmation has nowhere to show an
    // error and must keep the alert.
    hideDefaultAlert: !!hideDefaultAlert,
    types: [
      UPDATE_CUSTOMER_SUBMISSION_STATUS_REQUEST,
      UPDATE_CUSTOMER_SUBMISSION_STATUS_SUCCESS,
      UPDATE_CUSTOMER_SUBMISSION_STATUS_FAILURE,
    ],
  },
});

export const getCRMIssueHistory = (customerSubmissionId: number) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/${customerSubmissionId}/history`,
    method: 'get',
    authenticated: true,
    types: [
      GET_CUSTOMER_SUBMISSION_HISTORY_REQUEST,
      GET_CUSTOMER_SUBMISSION_HISTORY_SUCCESS,
      GET_CUSTOMER_SUBMISSION_HISTORY_FAILURE,
    ],
  },
});

export const clearCustomerSubmission = () => ({
  type: CLEAR_CUSTOMER_SUBMISSION,
});

export const editCRMAssignee = (customerSubmissionId: number, assigneeId: number) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/${customerSubmissionId}/assignees`,
    method: 'put',
    body: { assigneeId },
    authenticated: true,
    types: [EDIT_CRM_ASSIGNEE_REQUEST, EDIT_CRM_ASSIGNEE_SUCCESS, EDIT_CRM_ASSIGNEE_FAILURE],
  },
});

export const editCSVisibility = (customerSubmissionId: number, visibility: CRMCategoryVisibility) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/${customerSubmissionId}/visibility`,
    method: 'put',
    body: { visibility },
    authenticated: true,
    types: [EDIT_CS_VISIBILITY_REQUEST, EDIT_CS_VISIBILITY_SUCCESS, EDIT_CS_VISIBILITY_FAILURE],
  },
});

export const editCSDisplayOnPublicMap = (customerSubmissionId: number, displayOnPublicMap: boolean) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/${customerSubmissionId}/display-on-public-map`,
    method: 'put',
    body: { displayOnPublicMap },
    authenticated: true,
    types: [
      EDIT_CS_DISPLAY_ON_PUBLIC_MAP_REQUEST,
      EDIT_CS_DISPLAY_ON_PUBLIC_MAP_SUCCESS,
      EDIT_CS_DISPLAY_ON_PUBLIC_MAP_FAILURE,
    ],
  },
});

export const editCSCategory = (
  csId: number,
  categoryId: number,
  fields: Record<string, unknown>,
  reassignUsingSubmissionAssignmentRules: boolean = false,
  reassignUsingCategoryChangeRules: boolean = false,
  fieldsInfo: IFieldInfo[] = null
) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/${csId}/categories`,
    method: 'put',
    body: { categoryId, fields, reassignUsingSubmissionAssignmentRules, reassignUsingCategoryChangeRules, fieldsInfo },
    authenticated: true,
    types: [EDIT_CS_CATEGORY_REQUEST, EDIT_CS_CATEGORY_SUCCESS, EDIT_CS_CATEGORY_FAILURE],
  },
});

export const editCSCategoryFields = (csId: number, fieldValues: Record<string, unknown>) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/${csId}/category-custom-fields`,
    method: 'put',
    body: fieldValues,
    authenticated: true,
    types: [EDIT_CS_CATEGORY_FIELDS_REQUEST, EDIT_CS_CATEGORY_FIELDS_SUCCESS, EDIT_CS_CATEGORY_FIELDS_FAILURE],
  },
});

export const editCRMIssueLocation = (issueId: number, locationRequest: ICRMIssueLocationRequest) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/${issueId}/location`,
    method: 'put',
    body: locationRequest,
    authenticated: true,
    types: [CRM_EDIT_LOCATION_REQUEST, CRM_EDIT_LOCATION_SUCCESS, CRM_EDIT_LOCATION_FAILURE],
  },
});

export const enterCRMDraftMode = () => ({
  type: CRM_ENTER_DRAFT_MODE,
});

export const updateLocation = (issueLocation: ICRMIssueLocationResponse) => ({
  type: CRM_LOCATION_UPDATE,
  payload: issueLocation,
});

export const exitCRMDraftMode = () => ({
  type: CRM_EXIT_DRAFT_MODE,
});

export const addAttachments = (customerSubmissionId: number, attachments: ICRMAttachmentRequest[]) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/${customerSubmissionId}/attachments`,
    method: 'post',
    authenticated: true,
    body: { attachments },
    types: [CRM_ADD_ATTACHMENT_REQUEST, CRM_ADD_ATTACHMENT_SUCCESS, CRM_ADD_ATTACHMENT_FAILURE],
  },
});

export const deleteAttachments = (customerSubmissionId: number, attachmentIds: number[]) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/${customerSubmissionId}/attachments`,
    method: 'delete',
    authenticated: true,
    body: { attachmentIds },
    types: [CRM_DELETE_ATTACHMENT_REQUEST, CRM_DELETE_ATTACHMENT_SUCCESS, CRM_DELETE_ATTACHMENT_FAILURE],
  },
});

export const deleteAttachmentsById = (attachmentDisplayIds: number[]) => ({
  type: CRM_DELETE_ATTACHMENTS_BY_ID,
  response: attachmentDisplayIds,
});

export const downloadCSListCSV = (params?: ICustomerSubmissionListParams, sendEmail?: boolean) => {
  const queryParams: any = {};
  if (sendEmail) {
    queryParams.sendEmail = sendEmail;
  }

  return {
    [CALL_API]: {
      endpoint: `agencies/${baseURL}/summary/download`,
      method: 'post',
      params: queryParams,
      authenticated: true,
      body: params,
      types: [DOWNLOAD_CS_LIST_CSV_REQUEST, DOWNLOAD_CS_LIST_CSV_SUCCESS, DOWNLOAD_CS_LIST_CSV_FAILURE],
    },
  };
};

export const editCSCollaborators = (
  customerSubmissionId: number,
  collaboratorIds: number[],
  eventDispatch: EventsLabel,
  modifiedCollaborator?: number
) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/${customerSubmissionId}/collaborators`,
    method: 'put',
    body: { collaboratorIds, eventDispatch, modifiedCollaborator },
    authenticated: true,
    types: [EDIT_CS_COLLABORATOR_REQUEST, EDIT_CS_COLLABORATOR_SUCCESS, EDIT_CS_COLLABORATOR_FAILURE],
  },
});

export const updateEmailReadStatus = (
  customerSubmissionId: number,
  emails: Array<{ id: number; isRead: boolean }>
) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/${customerSubmissionId}/emails`,
    method: 'put',
    body: emails,
    authenticated: true,
    types: [UPDATE_EMAIL_READ_STATUS_REQUEST, UPDATE_EMAIL_READ_STATUS_SUCCESS, UPDATE_EMAIL_READ_STATUS_FAILURE],
  },
});

export const sendCSEmail = (customerSubmissionId: number, email: ICRMEmailRequest) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/${customerSubmissionId}/messages`,
    method: 'post',
    body: email,
    authenticated: true,
    types: [SEND_CS_EMAIL_REQUEST, SEND_CS_EMAIL_SUCCESS, SEND_CS_EMAIL_FAILURE],
  },
});

export const previewCSMessageTranslation = (customerSubmissionId: number, body: string) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/${customerSubmissionId}/messages/translation-preview`,
    method: 'post',
    body: { body },
    authenticated: true,
    hideDefaultAlert: true,
    hideLoadingWidget: true,
    types: [
      PREVIEW_CS_MESSAGE_TRANSLATION_REQUEST,
      PREVIEW_CS_MESSAGE_TRANSLATION_SUCCESS,
      PREVIEW_CS_MESSAGE_TRANSLATION_FAILURE,
    ],
  },
});

export const addCRMIssueNote = (customerSubmissionId: number, noteContent: string) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/${customerSubmissionId}/notes`,
    method: 'post',
    body: { noteContent },
    authenticated: true,
    types: [ADD_CRM_ISSUE_NOTE_REQUEST, ADD_CRM_ISSUE_NOTE_SUCCESS, ADD_CRM_ISSUE_NOTE_FAILURE],
  },
});

export const deleteCRMIssueNote = (customerSubmissionId: number, internalNoteId: number) => ({
  [CALL_API]: {
    // tslint:disable-next-line: max-line-length
    endpoint: `${agencyCRMIssuesBaseURL}/${customerSubmissionId}/notes/${internalNoteId}`,
    method: 'delete',
    authenticated: true,
    types: [DELETE_CRM_ISSUE_NOTE_REQUEST, DELETE_CRM_ISSUE_NOTE_SUCCESS, DELETE_CRM_ISSUE_NOTE_FAILURE],
  },
});

export const editCRMIssueNote = (customerSubmissionId: number, noteContent: string, internalNoteId: number) => ({
  [CALL_API]: {
    // tslint:disable-next-line: max-line-length
    endpoint: `${agencyCRMIssuesBaseURL}/${customerSubmissionId}/notes/${internalNoteId}`,
    method: 'put',
    body: { noteContent },
    authenticated: true,
    types: [EDIT_CRM_ISSUE_NOTE_REQUEST, EDIT_CRM_ISSUE_NOTE_SUCCESS, EDIT_CRM_ISSUE_NOTE_FAILURE],
  },
});

export const createSubmission = (submissionRequest: ICRMCreateSubmissionRequest) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}`,
    method: 'post',
    body: submissionRequest,
    authenticated: true,
    types: [CREATE_SUBMISSION_REQUEST, CREATE_SUBMISSION_SUCCESS, CREATE_SUBMISSION_FAILURE],
  },
});

export const getPrivateCSDPData = (token: string) => ({
  [CALL_API]: {
    endpoint: `crm/${privateCSDPBaseUrl}/${token}`,
    method: 'get',
    params: {
      token,
    },
    authenticated: false,
    types: [GET_PRIVATE_CSDP_DATA_REQUEST, GET_PRIVATE_CSDP_DATA_SUCCESS, GET_PRIVATE_CSDP_DATA_FAILURE],
    hideLoadingWidget: false,
  },
});

// Fetches the message history for the legacy magic-link CSDP page.
// The submission detail endpoint stopped returning `emails` in CDS-6722; messages
// now live behind GET /crm/submissions/private/{crmIssueId}/messages. The route
// authenticates via the magic-link token (?token=...), and the server enforces
// the token's bound `crmIssueId` over the path parameter (see
// getPrivateSubmissionMessages controller).
export const getPrivateCSDPMessages = (issueToken: string, crmIssueId: number) => ({
  [CALL_API]: {
    endpoint: `crm/${privateCSDPBaseUrl}/private/${crmIssueId}/messages`,
    method: 'get',
    params: {
      token: issueToken,
    },
    authenticated: false,
    types: [GET_PRIVATE_CSDP_MESSAGES_REQUEST, GET_PRIVATE_CSDP_MESSAGES_SUCCESS, GET_PRIVATE_CSDP_MESSAGES_FAILURE],
    hideLoadingWidget: true,
  },
});

export const resendMagicLink = (token: string) => ({
  [CALL_API]: {
    endpoint: `crm/submissions/${token}/resend-link`,
    method: 'post',
    authenticated: false,
    body: {},
    types: [RESEND_MAGIC_LINK_REQUEST, RESEND_MAGIC_LINK_SUCCESS, RESEND_MAGIC_LINK_FAILURE],
    hideLoadingWidget: false,
  },
});

export const sendPrivateCSMessage = (token: string, message: ICRMMessageRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${privateCSDPBaseUrl}/${token}/messages`,
    method: 'post',
    body: message,
    params: {
      token,
    },
    authenticated: false,
    types: [SEND_PRIVATE_CS_MESSAGE_REQUEST, SEND_PRIVATE_CS_MESSAGE_SUCCESS, SEND_PRIVATE_CS_MESSAGE_FAILURE],
  },
});

export const getPrivateSubmissionsList = (token: string, params: ICRMStatusParams) => {
  const agencyId = getAgencyId();
  console.log('Agency ID being sent in x-agency-id header:', agencyId);

  return {
    [CALL_API]: {
      endpoint: `${baseURL}/${privateCSLPBaseUrl}/${token}`,
      method: 'get',
      authenticated: false,
      params: {
        ...params,
        token,
      },
      headers: {
        'x-agency-id': agencyId,
      },
      types: [
        GET_PRIVATE_SUBMISSIONS_LIST_REQUEST,
        GET_PRIVATE_SUBMISSIONS_LIST_SUCCESS,
        GET_PRIVATE_SUBMISSIONS_LIST_FAILURE,
      ],
      hideLoadingWidget: false,
    },
  };
};

export const editCRMIssueDueByDate = (customerSubmissionId: number, reason: string, dueDate: string) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/${customerSubmissionId}/due-date`,
    method: 'put',
    body: { reason, dueDate },
    authenticated: true,
    types: [EDIT_CRM_ISSUE_DUE_BY_DATE_REQUEST, EDIT_CRM_ISSUE_DUE_BY_DATE_SUCCESS, EDIT_CRM_ISSUE_DUE_BY_DATE_FAILURE],
  },
});

export const editCRMIssueDescription = (customerSubmissionId: number, description: string) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/${customerSubmissionId}/description`,
    method: 'put',
    body: { description },
    authenticated: true,
    types: [EDIT_CRM_ISSUE_DESCRIPTION_REQUEST, EDIT_CRM_ISSUE_DESCRIPTION_SUCCESS, EDIT_CRM_ISSUE_DESCRIPTION_FAILURE],
  },
});

export const updateCRMIssueEscalation = (
  customerSubmissionId: number,
  updateEscalationRequest: ICRMIssueEscalationRequest
) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/${customerSubmissionId}/escalation`,
    method: 'put',
    body: updateEscalationRequest,
    authenticated: true,
    types: [
      UPDATE_CRM_ISSUE_ESCALATION_REQUEST,
      UPDATE_CRM_ISSUE_ESCALATION_SUCCESS,
      UPDATE_CRM_ISSUE_ESCALATION_FAILURE,
    ],
  },
});

export const getPrivateSubmissionListLink = (requestBody: ICRMPrivateSubmissionLinkRequest, token: string) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${privateCSLPBaseUrl}/${token}/generate-link`,
    method: 'post',
    body: requestBody,
    params: {
      token,
    },
    authenticated: false,
    types: [
      FETCH_PRIVATE_SUBMISSION_LIST_LINK_REQUEST,
      FETCH_PRIVATE_SUBMISSION_LIST_LINK_SUCCESS,
      FETCH_PRIVATE_SUBMISSION_LIST_LINK_FAILURE,
    ],
  },
});

export const addTask = (customerSubmissionId: number, task: ISubmissionTaskRequest) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/${customerSubmissionId}/tasks`,
    method: 'post',
    body: task,
    authenticated: true,
    types: [ADD_SUBMISSION_TASK_REQUEST, ADD_SUBMISSION_TASK_SUCCESS, ADD_SUBMISSION_TASK_FAILURE],
  },
});

export const fetchSubmissionTask = (taskId: number) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/tasks/${taskId}`,
    method: 'get',
    authenticated: true,
    types: [FETCH_SUBMISSION_TASK_REQUEST, FETCH_SUBMISSION_TASK_SUCCESS, FETCH_SUBMISSION_TASK_FAILURE],
  },
});

export const editSubmissionTask = (taskId: number, task: ISubmissionTaskRequest) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/tasks/${taskId}`,
    method: 'put',
    body: task,
    authenticated: true,
    types: [EDIT_SUBMISSION_TASK_REQUEST, EDIT_SUBMISSION_TASK_SUCCESS, EDIT_SUBMISSION_TASK_FAILURE],
  },
});

export const updateTaskStatus = (taskId: number, status: TaskStatus) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssueTaskBaseURL}/${taskId}/status`,
    method: 'put',
    body: { status },
    authenticated: true,
    types: [CRM_UPDATE_TASK_STATUS_REQUEST, CRM_UPDATE_TASK_STATUS_SUCCESS, CRM_UPDATE_TASK_STATUS_FAILURE],
  },
});

export const deleteSubmissionTask = (taskId: number) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/tasks/${taskId}`,
    method: 'delete',
    authenticated: true,
    types: [DELETE_SUBMISSION_TASK_REQUEST, DELETE_SUBMISSION_TASK_SUCCESS, DELETE_SUBMISSION_TASK_FAILURE],
  },
});

export const editCRMTaskComment = (taskId: number, commentId: number, newComment: string) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/task/${taskId}/comments/${commentId}`,
    method: 'put',
    body: { newComment },
    authenticated: true,
    types: [
      EDIT_SUBMISSION_TASK_COMMENT_REQUEST,
      EDIT_SUBMISSION_TASK_COMMENT_SUCCESS,
      EDIT_SUBMISSION_TASK_COMMENT_FAILURE,
    ],
  },
});

export const deleteCRMTaskComment = (taskId: number, commentId: number) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/task/${taskId}/comments/${commentId}`,
    method: 'delete',
    body: {},
    authenticated: true,
    types: [
      DELETE_SUBMISSION_TASK_COMMENT_REQUEST,
      DELETE_SUBMISSION_TASK_COMMENT_SUCCESS,
      DELETE_SUBMISSION_TASK_COMMENT_FAILURE,
    ],
  },
});

export const addTags = (issueId: number, tags: string[]) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/${issueId}/tags`,
    method: 'post',
    body: { tags },
    authenticated: true,
    types: [ADD_SUBMISSION_TAGS_REQUEST, ADD_SUBMISSION_TAGS_SUCCESS, ADD_SUBMISSION_TAGS_FAILURE],
  },
});

export const sendPrintRequest = (issueId: number) => ({
  [CALL_API]: {
    endpoint: `print/${issueId}?productType=crm`,
    method: 'get',
    authenticated: true,
    types: [SEND_SUBMISSION_PRINT_REQUEST, SEND_SUBMISSION_PRINT_SUCCESS, SEND_SUBMISSION_PRINT_FAILURE],
  },
});

export const checkPrintStatus = (issueId: number) => ({
  [CALL_API]: {
    endpoint: `print/${issueId}/status?productType=crm`,
    method: 'get',
    authenticated: true,
    hideLoadingWidget: true,
    types: [CHECK_PRINT_STATUS_REQUEST, CHECK_PRINT_STATUS_SUCCESS, CHECK_PRINT_STATUS_FAILURE],
  },
});

export const fetchRecentTags = (offset = 0, limit = 30) => ({
  [CALL_API]: {
    endpoint: `agencies/crm/recent-tags?limit=${limit}&offset=${offset}`,
    method: 'get',
    authenticated: true,
    hideLoadingWidget: true,
    types: [FETCH_RECENT_TAGS_REQUEST, FETCH_RECENT_TAGS_SUCCESS, FETCH_RECENT_TAGS_FAILURE],
  },
});

export const performGroupAction = (
  groupActionRequest: ICRMGroupActionRequest,
  params: IGroupActionsParams,
  hideDefaultAlert = false
) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMBaseURL}/group-actions`,
    method: 'post',
    authenticated: true,
    body: groupActionRequest,
    params,
    hideDefaultAlert,
    types: [GROUP_ACTION_REQUEST, GROUP_ACTION_SUCCESS, GROUP_ACTION_FAILURE],
  },
});

export const validateCrmLocation = (crmToken: string, params: ICRMLocationValidateParams) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${crmToken}/location/validate`,
    method: 'get',
    authenticated: false,
    params,
    types: [VALIDATE_LOCATION_REQUEST, VALIDATIE_LOCATION_SUCCESS, VALIDATE_LOCATION_FAILURE],
  },
});

export const fetchSecondaryCustomFields = () => ({
  [CALL_API]: {
    endpoint: `${agencyCRMBaseURL}/categories/criteria`,
    method: 'get',
    authenticated: true,
    types: [
      FETCH_SECONDARY_CUSTOM_FIELDS_REQUEST,
      FETCH_SECONDARY_CUSTOM_FIELDS_SUCCESS,
      FETCH_SECONDARY_CUSTOM_FIELDS_FAILURE,
    ],
  },
});

export const fetchAttachmentSourceOptions = () => ({
  [CALL_API]: {
    endpoint: `${agencyCRMBaseURL}/notification/attachment-source-options`,
    method: 'get',
    authenticated: true,
    types: [
      FETCH_ATTACHMENT_SOURCE_OPTIONS_REQUEST,
      FETCH_ATTACHMENT_SOURCE_OPTIONS_SUCCESS,
      FETCH_ATTACHMENT_SOURCE_OPTIONS_FAILURE,
    ],
  },
});

export const fetchCRMChannelOptions = (hideLoadingWidget = false) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/channel-options`,
    method: 'get',
    authenticated: true,
    types: [GET_CRM_CHANNEL_OPTIONS_REQUEST, GET_CRM_CHANNEL_OPTIONS_SUCCESS, GET_CRM_CHANNEL_OPTIONS_FAILURE],
    hideLoadingWidget,
  },
});

export const fetchCRMClosureOptions = (hideLoadingWidget = false) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/closure-options`,
    method: 'get',
    authenticated: true,
    types: [GET_CRM_CLOSURE_OPTIONS_REQUEST, GET_CRM_CLOSURE_OPTIONS_SUCCESS, GET_CRM_CLOSURE_OPTIONS_FAILURE],
    hideLoadingWidget,
  },
});

export const getSubmissionFollowers = (submissionId: number) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/${submissionId}/followers`,
    method: 'get',
    authenticated: true,
    types: [GET_SUBMISSION_FOLLOWERS_REQUEST, GET_SUBMISSION_FOLLOWERS_SUCCESS, GET_SUBMISSION_FOLLOWERS_FAILURE],
  },
});

export const addSubmissionFollower = (submissionId: number, body: IAddFollowerRequest) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/${submissionId}/followers`,
    method: 'post',
    body,
    authenticated: true,
    types: [ADD_SUBMISSION_FOLLOWER_REQUEST, ADD_SUBMISSION_FOLLOWER_SUCCESS, ADD_SUBMISSION_FOLLOWER_FAILURE],
  },
});

export const removeSubmissionFollower = (submissionId: number, contactId: number) => ({
  [CALL_API]: {
    endpoint: `${agencyCRMIssuesBaseURL}/${submissionId}/followers/${contactId}`,
    method: 'delete',
    authenticated: true,
    types: [REMOVE_SUBMISSION_FOLLOWER_REQUEST, REMOVE_SUBMISSION_FOLLOWER_SUCCESS, REMOVE_SUBMISSION_FOLLOWER_FAILURE],
  },
});

export const clearIssue = () => ({
  type: CLEAR_ISSUE,
});
